import { useQuery } from '@tanstack/react-query';
import { api } from './api.js';
import { useAuthStore } from '../stores/authStore.js';
import type { Entitlement } from '@blogforge/shared';

// ─────────────────────────────────────────────────────────────────
// Entitlement of the ACTIVE workspace (plan limits/features + live
// usage). Mirrors the backend guards; used to disable create CTAs and
// show upgrade prompts — the server still enforces, this is UX.
// ─────────────────────────────────────────────────────────────────

export function useEntitlement() {
  const activeWorkspaceId = useAuthStore((s) => s.activeWorkspaceId);
  return useQuery({
    queryKey: ['billing', 'entitlement', activeWorkspaceId],
    queryFn: () => api.billing.entitlement(),
    enabled: Boolean(activeWorkspaceId),
    staleTime: 30_000,
  });
}

export type { Entitlement };
